import React from 'react'
import styled from 'styled-components'

import * as Styled from './styled'

export interface OrderItemsPrintHeaderProps {
  className?: string
  printDiscountColumn: boolean
}

const OrderItemsPrintHeader: React.FC<OrderItemsPrintHeaderProps> = ({
  className,
  printDiscountColumn,
}) => {
  return (
    <div className={className}>
      <Styled.GapContainer>
        <Styled.ItemDetails>
          <Styled.PrintContainer>
            <Styled.ItemName>Item</Styled.ItemName>
            <Styled.ItemAttribute>Ordered</Styled.ItemAttribute>
            <Styled.ItemAttribute>Invoiced</Styled.ItemAttribute>
            <Styled.ItemAttribute>Shipped</Styled.ItemAttribute>
            <Styled.ItemAttribute>Unit Price</Styled.ItemAttribute>
            <Styled.ItemAmount>Amount</Styled.ItemAmount>
            {printDiscountColumn && <Styled.ItemAmount>Discount</Styled.ItemAmount>}
          </Styled.PrintContainer>
        </Styled.ItemDetails>
      </Styled.GapContainer>
    </div>
  )
}

const StyledOrderItemsPrintHeader = styled(OrderItemsPrintHeader)`
  overflow: hidden;
  display: none;
  @media print {
    display: table-header-group;
    // repeat table header after page break
    break-inside: avoid;
    border-bottom: 2px solid ${({ theme }) => theme.colors.brandBlue.dark300};
  }
  padding-left: 20px;
  padding-right: 20px;
`

export { StyledOrderItemsPrintHeader as OrderItemsPrintHeader }
